import { useQuery } from '@tanstack/react-query';

import { summaryQueries } from './queries';

type UseGetSummaryOptions = { enabled?: boolean };

export const useGetSummary = (
  pharmacyId: string | undefined,
  options: UseGetSummaryOptions = {}
) => {
  const { data: summary, isPending } = useQuery({
    ...summaryQueries.detail(pharmacyId),
    enabled: options.enabled ?? true,
  });

  return { summary, isPending };
};
